var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 2.16H9.12V0.96C9.12 0.4305 8.6895 0 8.16 0H3.36C2.8305 0 2.4 0.4305 2.4 0.96V2.16H0.48C0.2145 2.16 0 2.3745 0 2.64V3.12C0 3.186 0.054 3.24 0.12 3.24H1.026L1.3965 11.085C1.4205 11.5965 1.8435 12 2.355 12H9.165C9.678 12 10.0995 11.598 10.1235 11.085L10.494 3.24H11.4C11.466 3.24 11.52 3.186 11.52 3.12V2.64C11.52 2.3745 11.3055 2.16 11.04 2.16ZM8.04 2.16H3.48V1.08H8.04V2.16Z",
    fill: "#141850"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.4b5061cb.svg";
export { ForwardRef as ReactComponent };